<template>
  <b-overlay :show="collectionBusy">
    <portlet title="يېڭىدىن توپلام قوشۇش">
      <template v-slot:body>
        <collection-form
          ref="collection"
          @storing="onStoring"
          @stored="onStored"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button class="ml-2" variant="danger">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import CollectionForm from "@v@/components/forms/CollectionForm";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  export default {
    name: "index",
    components: { Portlet, CollectionForm },
    mixins: [ formBusyMixin ],
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'توپلام باشقۇرۇش', route: {name: 'collection.home'}});
      BreadCrumbs.addBreadCrumb({title: 'يېڭىدىن توپلام قوشۇش'});
      if ( this.$refs.hasOwnProperty('collection') ){
        this.form = this.$refs['collection'];
      }
    },
    data(){
      return {
        collectionBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onStoring(){
        this.showBusy('collectionBusy');
        debugConsole({prefix: 'collection', message: `onStored`});
      },
      onStored(res){
        let { state } = res;
        this.hideBusy('collectionBusy');
        debugConsole({prefix: 'collection', message: `onStored: ${res}`});
        state === 'success' && this.$router.replace({name: 'collection.home'});
      }
    }
  }
</script>

<style scoped>

</style>
